import { APPROVED_PR_STATUSES } from "Constants/ApprovedPRConstant";

export const API_ENDPOINT = {
  AUTH: {
    LOGIN: "/users/login",
    LOGOUT: "/users/logout",
    REFRESH_TOKEN: "/users/refresh-token",
  },
  ORGANIZATION: {
    ALL_ORG: "/organization/all-org/",
  },

  USER_MANAGEMENT: {
    ORGANIZATION: {
      LIST: "/user-management/organisation/list",
      CREATE: "/user-management/organisation/create",
      DETAIL: (id: string) => `/user-management/organisation/detail/${id}`,
      UPDATE: (id: string) => `/user-management/organisation/update/${id}`,
      DELETE: (id: string) => `/user-management/organisation/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/user-management/organisation/update-status/${id}`,
      DROPDOWN: "/user-management/organisation/dropdown/",
      FILTER_DROPDOWN: `/user-management/organisation/dropdown`,
      EXPORT: "/user-management/organisation/export",
    },
    DEPARTMENT: {
      LIST: "/user-management/department/list",
      CREATE: "/user-management/department/create",
      DETAIL: (id: string) => `/user-management/department/get/${id}`,
      UPDATE: (id: string) => `/user-management/department/update/${id}`,
      DELETE: (id: string) => `/user-management/department/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/user-management/department/update-status/${id}`,
      DROPDOWN: "/user-management/department/dropdown",
      FILTER_DROPDOWN: `/user-management/department/dropdown`,
      EXPORT: "/user-management/department/export",
      BY_ORG: (id: string) => `/user-management/department/by-org/${id}`,
    },
    TEAM: {
      LIST: "/user-management/team/list",
      CREATE: "/user-management/team/create",
      DETAIL: (id: string) => `/user-management/team/detail/${id}`,
      UPDATE: (id: string) => `/user-management/team/update/${id}`,
      DELETE: (id: string) => `/user-management/team/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/user-management/team/update-status/${id}`,
      DROPDOWN: (field: string) => `/user-management/team/dropdown/${field}`,
      FILTER_DROPDOWN: (field: string) =>
        `/user-management/team/dropdown/${field}`,
      EXPORT: "/user-management/team/export",
      BY_DEPARTMENT: (departmentId: string) =>
        `/user-management/team/get_teams_by_department_id/${departmentId}`,
    },
    USER_TYPE: {
      LIST: "/user-management/user-type/list",
      CREATE: "/user-management/user-type/create",
      DETAIL: (id: string) => `/user-management/user-type/detail/${id}`,
      UPDATE: (id: string) => `/user-management/user-type/update/${id}`,
      DELETE: (id: string) => `/user-management/user-type/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/user-management/user-type/update-status/${id}`,
      DROPDOWN: `/user-management/user-type/dropdown`,
      FILTER_DROPDOWN: (field: string) =>
        `/user-management/user-type/dropdown/${field}`,
      EXPORT: "/user-management/user-type/export",
    },
    USER: {
      LIST: "/users/list/",
      REGISTER: "/users/register/",
      CREATE: "/user-management/user/create",
      DETAIL: (id: string) => `/users/details/${id}`,
      UPDATE: (id: string) => `/users/edit/${id}/`,
      DELETE: (id: string) => `/user-management/user/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/users/edit/${id}/`,
      DROPDOWN: "/users/dropdown/all",
      FILTER_DROPDOWN: (field: string) =>
        `/user-management/user/filter-dropdown/?field_name=${field}`,
      EXPORT: "/user-management/user/export-csv",
      BY_TEAM: (teamId: string) =>
        `/user-management/user/dropdown/by_team_id/${teamId}`,
      GET_USER_PERMISSION: (id: string) =>
        `/user-management/permissions/user/${id}`,
      GET_USER_DROPDOWN_BY_TYPE: (type: string) =>
        `/user-management/user/dropdown/by_user_type/${type}`,
    },
    PERMISSION: {
      LIST: "/user-management/permissions",
      CREATE: "/user-management/permissions/create",
      DETAIL: (permissionId: string) =>
        `/user-management/permissions/${permissionId}`,
      UPDATE: (userId: string) =>
        `/user-management/permissions/update/${userId}`,
      DELETE: (permissionId: string) =>
        `/user-management/permissions/delete/${permissionId}`,
      CHECK_PERMISSION: "/user-management/permissions/check-permission",
      GET_USER_PERMISSIONS: (userId: string) =>
        `/user-management/permissions/permissions_list/${userId}`,
      CREATE_PERMISSIONS_LIST:
        "/user-management/permissions/permissions_list/create",
      UPDATE_PERMISSIONS_LIST: (userId: string) =>
        `/user-management/permissions/permissions_list/update/${userId}`,
      DELETE_ALL_PERMISSIONS: (userId: string) =>
        `/user-management/permissions/permissions_list/delete-all/${userId}`,
      GET_USER_PERMISSION_RESPONSE: (userId: string) =>
        `/user-management/permissions/user/${userId}`,
    },
    MODULE: {
      LIST: "/user-management/module-master/list",
      CREATE: "/user-management/module-master/create",
      DETAIL: (id: string) => `/user-management/module-master/detail/${id}`,
      UPDATE: (id: string) => `/user-management/module-master/update/${id}`,
      DELETE: (id: string) => `/user-management/module-master/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/user-management/module-master/update-status/${id}`,
      DROPDOWN: "/user-management/module-master/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/user-management/module-master/dropdown/${field}`,
      EXPORT: "/user-management/module-master/export",
    },
    SETTINGS: {
      GET: "/settings",
      UPDATE: "/settings/update",
      SET_CURRENT: "/settings/set-current",
    },
  },

  MASTERS: {
    CATEGORY: {
      LIST: "/masters/category/list",
      CREATE: "/masters/category/create",
      DETAIL: (id: string) => `/masters/category/${id}`,
      UPDATE: (id: string) => `/masters/category/update/${id}`,
      DELETE: (id: string) => `/masters/category/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/category/update-status/${id}`,
      DROPDOWN: "/masters/category/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/category/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/category/export-csv",
    },
    SUB_CATEGORY: {
      LIST: "/masters/sub-category/list",
      CREATE: "/masters/sub-category/create",
      DETAIL: (id: string) => `/masters/sub-category/detail/${id}`,
      UPDATE: (id: string) => `/masters/sub-category/update/${id}`,
      DELETE: (id: string) => `/masters/sub-category/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/masters/sub-category/update-status/${id}`,
      DROPDOWN: "/masters/sub-category/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/sub-category/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/sub-category/export-csv",
      DROPDOWN_BY_CATEGORY: (id: string) =>
        `/masters/sub-category/dropdown/?category_id=${id}`,
    },
    TYPE: {
      LIST: "/masters/type/list",
      CREATE: "/masters/type/create",
      DETAIL: (id: string) => `/masters/type/detail/${id}`,
      UPDATE: (id: string) => `/masters/type/update/${id}`,
      DELETE: (id: string) => `/masters/type/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/type/update-status/${id}`,
      DROPDOWN: "/masters/type/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/type/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/type/export-csv",
      DROPDOWN_BY_SUB_CATEGORY: (id: string) =>
        `/masters/type/dropdown/?sub_category_id=${id}`,
    },
    UNIT: {
      LIST: "/masters/unit/list",
      CREATE: "/masters/unit/create",
      DETAIL: (id: string) => `/masters/unit/${id}`,
      UPDATE: (id: string) => `/masters/unit/update/${id}`,
      DELETE: (id: string) => `/masters/unit/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/unit/update-status/${id}`,
      DROPDOWN: "/masters/unit/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/unit/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/unit/export-csv",
    },
    GST: {
      LIST: "/masters/gst/list",
      CREATE: "/masters/gst/create",
      DETAIL: (id: string) => `/masters/gst/${id}`,
      UPDATE: (id: string) => `/masters/gst/update/${id}`,
      DELETE: (id: string) => `/masters/gst/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/gst/update-status/${id}`,
      DROPDOWN: "/masters/gst/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/gst/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/gst/export-csv",
    },
    HSN_CODE: {
      LIST: "/masters/hsn-code/list",
      CREATE: "/masters/hsn-code/create",
      DETAIL: (id: string) => `/masters/hsn-code/${id}`,
      UPDATE: (id: string) => `/masters/hsn-code/update/${id}`,
      DELETE: (id: string) => `/masters/hsn-code/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/hsn-code/update-status/${id}`,
      DROPDOWN: "/masters/hsn-code/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/hsn-code/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/hsn-code/export-csv",
    },
    SAC_CODE: {
      LIST: "/masters/sac-code/list",
      CREATE: "/masters/sac-code/create",
      DETAIL: (id: string) => `/masters/sac-code/${id}`,
      UPDATE: (id: string) => `/masters/sac-code/update/${id}`,
      DELETE: (id: string) => `/masters/sac-code/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/sac-code/update-status/${id}`,
      DROPDOWN: "/masters/sac-code/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/sac-code/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/sac-code/export-csv",
    },
    CURRENCY: {
      LIST: "/masters/currency/list",
      CREATE: "/masters/currency/create",
      DETAIL: (id: string) => `/masters/currency/${id}`,
      UPDATE: (id: string) => `/masters/currency/update/${id}`,
      DELETE: (id: string) => `/masters/currency/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/currency/update-status/${id}`,
      DROPDOWN: "/masters/currency/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/currency/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/currency/export-csv",
    },
    MAKE: {
      LIST: "/masters/make/list",
      CREATE: "/masters/make/create",
      DETAIL: (id: string) => `/masters/make/${id}`,
      UPDATE: (id: string) => `/masters/make/update/${id}`,
      DELETE: (id: string) => `/masters/make/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/make/update-status/${id}`,
      DROPDOWN: "/masters/make/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/make/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/make/export-csv",
    },
    MODEL: {
      LIST: "/masters/model/list",
      CREATE: "/masters/model/create",
      DETAIL: (id: string) => `/masters/model/${id}`,
      UPDATE: (id: string) => `/masters/model/update/${id}`,
      DELETE: (id: string) => `/masters/model/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/model/update-status/${id}`,
      DROPDOWN: "/masters/model/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/model/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/model/export-csv",
      DROPDOWN_BY_MAKE: (id: string) =>
        `/masters/model/dropdown/?make_id=${id}`,
    },
    PRODUCT: {
      LIST: "/masters/product/list",
      CREATE: "/masters/product/create",
      DETAIL: (id: string) => `/masters/product/${id}`,
      UPDATE: (id: string) => `/masters/product/update/${id}`,
      DELETE: (id: string) => `/masters/product/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/product/update-status/${id}`,
      DROPDOWN: "/masters/product/dropdown",
      MODEL_DROPDOWN: "/masters/product/model-dropdown",
      DROPDOWN_BY_MODEL: (model_id: string) =>
        `/masters/product/by-model/${model_id}`,
      FILTER_DROPDOWN: (field: string) =>
        `/masters/product/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/product/export-csv",
      EXPORT_TALLY: "/masters/product/export-tally-csv",
    },
 
    CUSTOMER: {
      LIST: "/masters/customer/list",
      CREATE: "/masters/customer/create",
      DETAIL: (id: string) => `/masters/customer/detail/${id}`,
      UPDATE: (id: string) => `/masters/customer/update/${id}`,
      DELETE: (id: string) => `/masters/customer/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/customer/update-status/${id}`,
      DROPDOWN: "/masters/customer/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/customer/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/customer/export-csv",
      EXPORT_TALLY: "/masters/customer/export-tally-csv",
      UpdateShippingAddress: (company_id: string) =>
        `/masters/customer/add-shipping-address/${company_id}`,
    },
    WAREHOUSE: {
      LIST: "/masters/warehouse/list",
      CREATE: "/masters/warehouse/create",
      DETAIL: (id: string) => `/masters/warehouse/${id}`,
      UPDATE: (id: string) => `/masters/warehouse/update/${id}`,
      DELETE: (id: string) => `/masters/warehouse/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/warehouse/update-status/${id}`,
      ENABLE_FIFO_STATUS: (id: string) =>
        `/masters/warehouse/enable_fifo_status/${id}`,
      DROPDOWN: "/masters/warehouse/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/warehouse/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/warehouse/export-csv",
      CONFIGURATION: {
        LIST: (warehouseId: string) =>
          `/masters/configure_warehouse/?warehouse_id=${warehouseId}`,
        CREATE: (warehouseId: string) => `/masters/configure_warehouse/create`,
        DELETE: (configId: string) =>
          `/masters/configure_warehouse/soft_delete/${configId}`,
        USERS_BY_ORG_DEPT_TEAM: "/masters/users/by_org_dept_team/",
        WAREHOUSE_BY_USER: "/masters/configure_warehouse/user-warehouse",
      },
    },

    // WAREHOUSE_CONFIGURATION: {
    //   LIST: (warehouseId: string) => `/masters/configure_warehouse/${warehouseId}/`,
    //   DETAIL: (configId: string) => `/masters/configure_warehouse/detail/${configId}/`,
    //   CREATE: (warehouseId: string) => `/masters/configure_warehouse/create/${warehouseId}/`,
    //   DELETE: (configId: string) => `/masters/configure_warehouse/soft_delete/${configId}/`,
    //   USERS_BY_ORG_DEPT_TEAM: "/masters/users/by_org_dept_team/",
    // },
    SUPPLIER: {
      LIST: "/masters/supplier/list",
      CREATE: "/masters/supplier/create",
      DETAIL: (id: string) => `/masters/supplier/${id}`,
      UPDATE: (id: string) => `/masters/supplier/update/${id}`,
      DELETE: (id: string) => `/masters/supplier/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/masters/supplier/update-status/${id}`,
      DROPDOWN: "/masters/supplier/dropdown",
      DROPDOWN_BY_PR: "/masters/supplier/dropdown-by-pr",
      FILTER_DROPDOWN: (field: string) =>
        `/masters/supplier/filter-dropdown?field_name=${field}`,
      BRANCH_DROPDOWN_BY_SUPPLIER_ID: (supplier_id: string) =>
        `/masters/supplier/branches?supplier_id=${supplier_id}`,
      SUPPLYABLE_PRODUCTS: "/masters/supplier/supplyable-products",
      EXPORT: "/masters/supplier/export-csv",
    },
    TERMS_AND_CONDITIONS: {
      LIST: "/masters/terms_and_conditions/list",
      CREATE: "/masters/terms_and_conditions/create",
      DETAIL: (id: string) => `/masters/terms_and_conditions/detail/${id}`,
      UPDATE: (id: string) => `/masters/terms_and_conditions/update/${id}`,
      DELETE: (id: string) => `/masters/terms_and_conditions/soft_delete/${id}`,
      FILTER_DROPDOWN: (field: string) =>
        `/masters/terms_and_conditions/filter-dropdown?field_name=${field}`,
      EXPORT: "/masters/terms_and_conditions/export-csv",
      STATUS_UPDATE: (id: string) =>
        `/masters/terms_and_conditions/update-status/${id}`,
      DROPDOWN: "/masters/terms_and_conditions/dropdown",
      OPTIONS_DROPDOWN_BY_TYPE: (type: string) =>
        `/masters/terms_and_conditions/options/${type}`,
    },
  },

  ENQUIRY: {
    PRODUCT: {
      LIST: "/order/enquiry/product/list",
      CREATE: "/order/enquiry/product/create",
      DETAIL: (id: string) => `/order/enquiry/product/detail/${id}`,
      UPDATE: (id: string) => `/order/enquiry/product/update/${id}`,
      DELETE: (id: string) => `/order/enquiry/product/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/order/enquiry/product/update-status/${id}`,
      DROPDOWN: "/enquiry/product/dropdown",
      FILTER_DROPDOWN: (field: string, type: string, enquiry_stage: string) =>
        `/order/enquiry/${type}/filter-dropdown?field_name=${field}&enquiry_stage=${enquiry_stage}`,
      EXPORT: "/order/enquiry/product/export",
    },
    SERVICE: {
      LIST: "/order/enquiry/service/list",
      CREATE: "/order/enquiry/service/create",
      DETAIL: (id: string) => `/order/enquiry/service/detail/${id}`,
      UPDATE: (id: string) => `/order/enquiry/service/update/${id}`,
      DELETE: (id: string) => `/order/enquiry/service/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/order/enquiry/service/update-status/${id}`,
      DROPDOWN: "/order/enquiry/service/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/order/enquiry/service/filter-dropdown?field=${field}`,
      EXPORT: "/order/enquiry/service/export",
    },
    FOLLOW_UP: {
      CREATE: "/order/follow-up/create",
      DETAIL: "/order/follow-up/detail",
    },
  },

  QUOTATION: {
    PRODUCT: {
      LIST: "/quotations/product/list",
      CREATE: "/quotations/product/create",
      DETAIL: (id: string) => `/quotations/product/detail/${id}`,
      UPDATE: (id: string) => `/quotations/product/update/${id}`,
      DELETE: (id: string) => `/quotations/product/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/quotations/product/status/${id}`,
      DROPDOWN: "/quotations/product/dropdown",
      DYNAMIC_DROPDOWN: (field: string) =>
        `/quotations/product/dynamic_dropdown/${field}`,
      FILTER_DROPDOWN: (field: string, quotation_stage: string) =>
        `/quotations/product/filter-dropdown?field=${field}&quotation_stage=${quotation_stage}`,
      EXPORT: "/quotations/product/export",
      DROPDOWN_FOR_QUOTATION_NUMBER: `/quotations/product/dropdown/`,
      DOWNLOAD_PDF: (id: string) => `/pdf/quotation/product/${id}`,
      EMAIL_DETAILS: (id: string) => `/quotations/product/email-details/${id}`,
    },
    SERVICE: {
      LIST: "/quotations/service/list",
      CREATE: "/quotations/service/create",
      DETAIL: (id: string) => `/quotations/service/detail/${id}`,
      UPDATE: (id: string) => `/quotations/service/update/${id}`,
      DELETE: (id: string) => `/quotations/service/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/quotations/service/status/${id}`,
      DROPDOWN: "/quotations/service/dropdown",
      DYNAMIC_DROPDOWN: (field: string) =>
        `/quotations/service/dynamic_dropdown/${field}`,
      FILTER_DROPDOWN: (field: string, quotation_stage: string) =>
        `/quotations/service/filter-dropdown?field=${field}&quotation_stage=${quotation_stage}`,
      EXPORT: "/quotations/service/export",
      DROPDOWN_FOR_QUOTATION_NUMBER: `/quotations/service/dropdown/`,
      DOWNLOAD_PDF: (id: string) => `/pdf/quotation/service/${id}`,
    },
  },

  SALES_ORDER: {
    PRODUCT: {
      LIST: "/order/sales_order/product/list",
      CREATE: "/order/sales_order/product/create",
      DETAIL: (id: string) => `/order/sales_order/product/details/${id}`,
      UPDATE: (id: string) => `/order/sales_order/product/update/${id}`,
      DELETE: (id: string) => `/order/sales_order/product/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/order/sales_order/product/status/${id}`,
      DROPDOWN: "/order/sales_order/product/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/order/sales_order/product/filter-dropdown?field=${field}`,
      EXPORT: "/order/sales_order/product/export-csv",
      EXPORT_TALLY: "/order/sales_order/product/export-tally-csv",
      ISSUE_PACKING: (id: string) =>
        `/order/sales_order/product/issue-for-packing/${id}`,
      REVERT_STATUS_UPDATE: (id: string) =>
        `/order/sales_order/product/delete/${id}`,
      GENERATE_PI: (id: string) =>
        `/order/sales_order/product/generate-pi/${id}`,
      DOWNLOAD_PDF: (id: string) => `/pdf/sales-order/product/${id}`,
      DOWNLOAD_ACKNOWLEDGEMENT_PDF: (id: string) =>
        `/pdf/sales-order/product-acknowledgement/${id}`,
    },
    SERVICE: {
      LIST: "/order/sales_order/service/list",
      CREATE: "/order/sales_order/service/create",
      DETAIL: (id: string) => `/order/sales_order/service/details/${id}`,
      UPDATE: (id: string) => `/order/sales_order/service/update/${id}`,
      DELETE: (id: string) => `/order/sales_order/service/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/order/sales_order/service/status/${id}`,
      DROPDOWN: "/order/sales_order/service/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/order/sales_order/service/filter-dropdown?field=${field}`,
      EXPORT: "/order/sales_order/service/export-csv",
      REVERT_STATUS_UPDATE: (id: string) =>
        `/order/sales_order/service/delete/${id}`,
      GENERATE_PI: (id: string) =>
        `/order/sales_order/service/generate-pi/${id}`,
      GENERATE_PDF: (id: string) =>
        `/pdf/sales-order/service-pi/${id}`,
      GENERATE_SERVICE_CHALLAN_PDF: (id: string) =>
        `/pdf/sales-order/service-challan/${id}`,
      SERVICE_COMPLETED: (id: string) =>
        `/order/sales_order/service/service-completion/${id}`,
      SERVICE_ITEM_COMPLETED: (id: string) =>
        `/order/sales_order/service/service-completion-item/${id}`,
      CALIBRATION_ENGINEER_PDF: (id: string) =>  `/pdf/sales-order/calibration/${id}`,
      REQUISITION_PDF: (id: string) =>  `/pdf/sales-order/requisition/${id}`,
      CHALLAN: {
        CREATE: "/order/challan/create",
        LIST: (id: string) => `/order/challan/list/${id}`,
        GET_BY_ID: (id: string) => `/order/challan/${id}`,
        UPDATE: (id: string) => `/order/challan/${id}`,
        GET_CREATE_DATA: (id: string) => `/order/challan/create-metadata/${id}`,
        DOWNLOAD_PDF: (id: string) => `/pdf/challan/${id}`,
        ACCESSORY_RETURNS: (id: string) => `/order/challan/${id}/accessory-returns`,
        ACCESSORY_RETURNS_EDIT: (challanId: string, returnId: string) =>
          `/order/challan/${challanId}/accessory-returns/${returnId}/edit`,
        ACCESSORY_RETURNS_UPDATE: (challanId: string, returnId: string) =>
          `/order/challan/${challanId}/accessory-returns/${returnId}`,
      },
    },
  },

  FOLLOW_UP: {
    CREATE: "/order/follow-up/create",
    DETAIL: "/order/follow-up/detail",
  },

  PURCHASE_MANAGEMENT: {
    PURCHASE_REQUEST: {
      LIST: "/purchase-management/purchase-request/list",
      CREATE: "/purchase-management/purchase-request/create",
      APPROVE_REJECT_PR: (pr_id: string) =>
        `/purchase-management/purchase-request/approve-pr/${pr_id}`,
      DETAIL: (id: string) => `/purchase-management/purchase-request/${id}`,
      UPDATE: (id: string) =>
        `/purchase-management/purchase-request/update/${id}`,
      DELETE: (id: string) =>
        `/purchase-management/purchase-request/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/purchase-management/purchase-request/update-status/${id}`,
      DROPDOWN: "/purchase-management/purchase-request/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/purchase-management/purchase-request/filter-dropdown?field_name=${field}`,
      FILTER_DROPDOWN_APPROVED_PR: (field: string) =>
        `/purchase-management/purchase-request/filter-dropdown?field_name=${field}&status_in=${APPROVED_PR_STATUSES.map((s) => encodeURIComponent(s)).join(",")}`,
      EXPORT: "/purchase-management/purchase-request/export-csv",
      PR_ANALYTICS: "/purchase-management/purchase-request/pr-analytics",
    },
    APPROVED_PURCHASE_REQUEST: {
      DROPDOWN: "/purchase-management/approved-purchase-request/dropdown",
      PR_PRODUCTS_BY_PR_IDS:
        "/purchase-management/approved-purchase-request/supplier-products-by-pr-ids",
      DROPDOWN_BY_SUPPLIER_ID: (supplier_id: string) =>
        `/purchase-management/approved-purchase-request/dropdown-by-supplier-id?supplier_id=${supplier_id}`,
      DROPDOWN_BY_SUPPLIER_ID_FOR_EDIT: (supplier_id: string, po_id: string) =>
        `/purchase-management/approved-purchase-request/dropdown-by-supplier-id-for-edit?supplier_id=${supplier_id}&po_id=${po_id}`,
      REVERT_APPROVED_PR: (pr_id: string) =>
        `/purchase-management/approved-purchase-request/revert-approve-pr/${pr_id}`,
    },
    PURCHASE_ORDER: {
      LIST: "/purchase-management/purchase-order/list",
      CREATE: "/purchase-management/purchase-order/create",
      DETAIL: (id: string) => `/purchase-management/purchase-order/${id}`,
      UPDATE: (id: string) =>
        `/purchase-management/purchase-order/update/${id}`,
      DELETE: (id: string) =>
        `/purchase-management/purchase-order/delete/${id}`,
      STATUS_UPDATE: (id: string) =>
        `/purchase-management/purchase-order/status/${id}`,
      REVERT_PURCHASE_ORDER: (id: string) =>
        `/purchase-management/purchase-order/revert/${id}`,
      PO_ANALYTICS: "/purchase-management/purchase-order/po-analytics",
      DROPDOWN: "/purchase-management/purchase-order/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/purchase-management/purchase-order/filter-dropdown?field_name=${field}`,
      EXPORT: "/purchase-management/purchase-order/export-csv",
      DOWNLOAD_PDF: (id: string) =>
        `/purchase-management/purchase-order/pdf/${id}`,
    },
    DIRECT_PURCHASE_ORDER: {
      GET_MODELS_BY_SUPPLIER: (supplier_id: string) => 
        `/purchase-management/direct-purchase-order/supplier/${supplier_id}/models`,
      GET_PRODUCTS_BY_SUPPLIER_AND_MODEL: (supplier_id: string, model_id: string) =>
        `/purchase-management/direct-purchase-order/supplier/${supplier_id}/model/${model_id}/products`,
    }
  },

  INVENTORY: {
    PRODUCT_HISTORY: (serial_no: string) =>
      `/inventory/product-history/${serial_no}`,
    IN_STOCK: {
      STOCKOVERVIEW: {
        LIST: "/inventory/instock/stock-overview/list",
        CREATE: "/inventory/in-stock/create",
        DETAIL: `/inventory/instock/stock-overview/details`,
        UPDATE: (id: string) => `/inventory/in-stock/update/${id}`,
        DELETE: (id: string) => `/inventory/in-stock/delete/${id}`,
        STATUS_UPDATE: (id: string) => `/inventory/in-stock/status/${id}`,
        DROPDOWN: "/inventory/in-stock/dropdown",
        FILTER_DROPDOWN: (field: string, warehouseId: string) =>
          `/inventory/instock/stock-overview/filter-dropdown?field=${field}&warehouse_id=${warehouseId}`,
        DetailedFilterDropdown: (
          field: string,
          productId: string,
          warehouseId: string
        ) =>
          `/inventory/instock/stock-overview/detailed-filter-dropdown?field=${field}&product_id=${productId}&warehouse_id=${warehouseId}`,
        EXPORT: (warehouse_id: string) =>
          `/inventory/instock/stock-overview/export?warehouse_id=${warehouse_id}`,
      },
      SupplierStock: {
        LIST: "/inventory/instock/supplier-stock/list",
        FILTER_DROPDOWN: (field: string, warehouseId: string) =>
          `/inventory/instock/supplier-stock/filter-dropdown?field=${field}&warehouse_id=${warehouseId}`,
        EXPORT: "/inventory/instock/supplier-stock/export",
      },
    },
    REORDER_LEVEL: {
      LIST: "/inventory/reorder-level/list",
      CREATE: "/inventory/reorder-level/create",
      DETAIL: (id: string) => `/inventory/reorder-level/detail/${id}`,
      UPDATE: (id: string) => `/inventory/reorder-level/update/${id}`,
      DELETE: (id: string) => `/inventory/reorder-level/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/inventory/reorder-level/status/${id}`,
      DROPDOWN: "/inventory/reorder-level/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/inventory/reorder-level/filter-dropdown?field=${field}`,
      EXPORT: "/inventory/reorder-level/export",
    },
  },

  WAREHOUSE: {
    STOCK_OVERVIEW: {
      DAILY_LOG: {
        LIST: (warehouse_id: string) =>
          `/warehouse/daily-log/list?warehouse_id=${warehouse_id}`,
        DROPDOWN: "/warehouse/daily-log/dropdown",
        EXPORT: (warehouse_id: string) =>
          `/warehouse/daily-log/export?warehouse_id=${warehouse_id}`,
        FILTER_DROPDOWN: (field: string, warehouse_id?: string) =>
          warehouse_id
            ? `/warehouse/daily-log/filter-dropdown?field=${field}&warehouse_id=${warehouse_id}`
            : `/warehouse/daily-log/filter-dropdown?field=${field}`,
      },
      IN_STOCK: {
        LIST: (warehouse_id: string) =>
          `/warehouse/in-stock/list?warehouse_id=${warehouse_id}`,
        DETAIL: (product_id: string, warehouse_id: string) =>
          `/warehouse/in-stock/details/${product_id}?warehouse_id=${warehouse_id}`,
        DROPDOWN: (field: string, warehouse_id: string) =>
          `/warehouse/in-stock/filter-dropdown?field=${field}&warehouse_id=${warehouse_id}`,
        DETAILS_DROPDOWN: (
          field: string,
          warehouse_id: string,
          product_id: string
        ) =>
          `/warehouse/in-stock/details-filter-dropdown?field=${field}&warehouse_id=${warehouse_id}&product_id=${product_id}`,
        EXPORT: (warehouse_id: string) =>
          `/warehouse/in-stock/export?warehouse_id=${warehouse_id}`,
      },
      LIST: "/warehouse/stock-overview",
      CREATE: "/warehouse/stock-overview/create",
      DETAIL: (id: string) => `/warehouse/stock-overview/detail/${id}`,
      UPDATE: (id: string) => `/warehouse/stock-overview/update/${id}`,
      DELETE: (id: string) => `/warehouse/stock-overview/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/warehouse/stock-overview/status/${id}`,
      DROPDOWN: "/warehouse/stock-overview/dropdown",
      FILTER_DROPDOWN: (field: string) =>
        `/warehouse/stock-overview/filter-dropdown?field=${field}`,
      EXPORT: "/warehouse/stock-overview/export",
    },
    ITEM_INWARD: {
      PENDING_PO: {
        LIST: "/warehouse/item-inward/list",
        CREATE: "/warehouse/item-inward/create",
        DETAIL: (id: string) => `/warehouse/item-inward/detail/${id}`,
        UPDATE: (id: string) => `/warehouse/item-inward/update/${id}`,
        DELETE: (id: string) => `/warehouse/item-inward/delete/${id}`,
        STATUS_UPDATE: (id: string) => `/warehouse/item-inward/status/${id}`,
        DROPDOWN: "/warehouse/item-inward/dropdown",
        FILTER_DROPDOWN: (field: string, warehouseId?: string) =>
          `/warehouse/item-inward/filter-dropdown?field_name=${field}&warehouse_id=${warehouseId}`,
        EXPORT: "/warehouse/item-inward/export-csv",
      },
      ANALYTICS: "/warehouse/item-inward/item-inward-analytics",
      GRN: {
        LIST: "/warehouse/grn/list",
        CREATE: "/warehouse/grn/create",
        DETAIL: (id: string) => `/warehouse/grn/${id}`,
        UPDATE: (id: string) => `/warehouse/grn/update/${id}`,
        DELETE: (id: string) => `/warehouse/grn/delete/${id}`,
        STATUS_UPDATE: (id: string) => `/warehouse/grn/status/${id}`,
        DROPDOWN: "/warehouse/grn/dropdown",
        FILTER_DROPDOWN: (field: string, warehouseId?: string) =>
          warehouseId
            ? `/warehouse/grn/filter-dropdown?field_name=${field}&warehouse_id=${warehouseId}`
            : `/warehouse/grn/filter-dropdown?field_name=${field}`,
        SERIAL_NO_DROPDOWN: (product_id: string, warehouse_id?: string) =>
          `/warehouse/grn/serial-numbers-dropdown?product_id=${product_id}&warehouse_id=${warehouse_id}&available_only=true`,
        INVENTORY_ITEMS_DETAIL: (inventory_id: String, product_id: String) =>
          `/warehouse/grn/${inventory_id}/products/${product_id}`,
        REVERT: (id: string) => `/warehouse/grn/revert/${id}`,
        EXPORT: "/warehouse/grn/export-csv",
      },
      CHALLAN_ACCESSORY_INWARD: {
        FILTER_DROPDOWN: (field: string, warehouseId?: string) =>
          warehouseId
            ? `/warehouse/challan-accessory-inward/filter-dropdown?field_name=${field}&warehouse_id=${warehouseId}`
            : `/warehouse/challan-accessory-inward/filter-dropdown?field_name=${field}`,
        PENDING_CHALLANS: (warehouseId?: string) =>
          `/warehouse/challan-accessory-inward/pending-challans${warehouseId ? `?warehouse_id=${warehouseId}` : ""}`,
        INWARD_FORM: (challanId: string, returnId?: string) =>
          `/warehouse/challan-accessory-inward/${challanId}/inward-form${returnId ? `?return_id=${returnId}` : ''}`,
        PROCESS: (challanId: string, returnId: string) =>
          `/warehouse/challan-accessory-inward/${challanId}/returns/${returnId}/process`,
        EXPORT: "/warehouse/challan-accessory-inward/export-csv",
      },
      RETURNED_ACCESSORIES_GRN: {
        FILTER_DROPDOWN: (field: string, warehouseId?: string) =>
          warehouseId
            ? `/warehouse/returned-accessories-grn/filter-dropdown?field_name=${field}&warehouse_id=${warehouseId}`
            : `/warehouse/returned-accessories-grn/filter-dropdown?field_name=${field}`,
        ANALYTICS: (warehouseId?: string) =>
          `/warehouse/returned-accessories-grn/analytics${warehouseId ? `?warehouse_id=${warehouseId}` : ""}`,
        ALL_INWARDS: (warehouseId?: string) =>
          `/warehouse/returned-accessories-grn/list${warehouseId ? `?warehouse_id=${warehouseId}` : ""}`,
        GRN_LIST: (challanId: string) =>
          `/warehouse/returned-accessories-grn/${challanId}/grn-list`,
        GRN_DETAIL: (inwardId: string) =>
          `/warehouse/returned-accessories-grn/${inwardId}`,
        REVERT: (inwardId: string) =>
          `/warehouse/returned-accessories-grn/${inwardId}/revert`,
        EDIT: (inwardId: string) =>
          `/warehouse/returned-accessories-grn/${inwardId}`,
        EXPORT: "/warehouse/returned-accessories-grn/export-csv",
      },
    },
    PACKING: {
      LIST: "/warehouse/issue-for-packing/list",
      CREATE: "/warehouse/packing-done/create-packing",
      DETAIL: (id: string) => `/warehouse/issue-for-packing/details/${id}`,
      UPDATE: (id: string) => `/warehouse/packing/update/${id}`,
      DELETE: (id: string) => `/warehouse/packing/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/warehouse/packing/status/${id}`,
      DROPDOWN: "/warehouse/packing/dropdown",
      FILTER_DROPDOWN: (field: string, warehouseId?: string) =>
        `/warehouse/issue-for-packing/filter-dropdown?field=${field}&warehouse_id=${warehouseId}`,
      EXPORT: "/warehouse/issue-for-packing/export",
      FetchPackingPreview: (id: string) =>
        `/warehouse/issue-for-packing/packing-preview/${id}`,
      REVERT: (sales_order_product_id: string) => `/warehouse/issue-for-packing/packing-revert/${sales_order_product_id}`
    },
    PACKING_DONE: {
      LIST: "/warehouse/packing-done/list",
      CREATE: "/warehouse/packing-done/create-packing",
      DETAIL: (id: string) => `/warehouse/packing-done/detail/${id}`,
      UPDATE: (id: string) => `/warehouse/packing-done/update-packing/${id}`,
      DELETE: (id: string) => `/warehouse/packing-done/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/warehouse/packing-done/status/${id}`,
      DROPDOWN: "/warehouse/packing-done/dropdown",
      FILTER_DROPDOWN: (field: string,warehouseId?:string) =>
        `/warehouse/packing-done/filter-dropdown?field=${field}&warehouse_id=${warehouseId}`,
      EXPORT: `/warehouse/packing-done/export`,
      REVERT: (id: string) => `/warehouse/packing-done/revert/${id}`,
    },
    DISPATCH: {
      LIST: "/warehouse/dispatch/list",
      CREATE: "/warehouse/dispatch/create",
      DETAIL: (id: string) => `/warehouse/dispatch/${id}`,
      UPDATE: (id: string) => `/warehouse/dispatch/update/${id}`,
      DELIVERY_DONE: (id: string) => `/warehouse/dispatch/delivery-done/${id}`,
      REVERT_DISPATCH: (id: string) => `/warehouse/dispatch/revert/${id}`,
      DELETE: (id: string) => `/warehouse/dispatch/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/warehouse/dispatch/status/${id}`,
      DROPDOWN: "/warehouse/dispatch/dropdown",
      FILTER_DROPDOWN: (field: string, warehouse_id: string) =>
        `/warehouse/dispatch/filter-dropdown?field_name=${field}&warehouse_id=${warehouse_id}`,
      EXPORT: "/warehouse/dispatch/export-csv",
      SO_DROPDOWN_FOR_DISPATCH: (warehouse_id: string) =>
        `/warehouse/dispatch/sales-order-dropdown-for-dispatch?warehouse_id=${warehouse_id}`,
      SO_AND_SHIPPING_ADDRESS_DROPDOWN_FOR_DISPATCH: (
        sales_order_product_id: string
      ) =>
        `/warehouse/dispatch/sales-order-product-with-shipping-address/${sales_order_product_id}`,
      PACKING_DROPDOWN_BY_SO_AND_SHIPPING: (
        sales_order_product_id: string,
        shipping_address_id: string
      ) =>
        `/warehouse/dispatch/packing-dropdown-by-sales-order-and-shipping?sales_order_product_id=${sales_order_product_id}&shipping_address_id=${shipping_address_id}`,
      PACKING_DROPDOWN_BY_SO_AND_SHIPPING_FOR_EDIT_DISPATCH: (
        sales_order_product_id: string,
        shipping_address_id: string
      ) =>
        `/warehouse/dispatch/packing-dropdown-by-sales-order-and-shipping-for-edit-dispatch?sales_order_product_id=${sales_order_product_id}&shipping_address_id=${shipping_address_id}`,
      PACKING_PRODUCTS_BY_PACKING_IDS: (packingIds: any[]) =>
        `/warehouse/dispatch/packing-products-by-packing-ids?packing_ids=${packingIds}`,
      PDF_CHALLAN: (id: string) => `/pdf/dispatch/dispatchChallan/${id}`,
    },
    // DISPATCH: {
    //   LIST: "/warehouse/dispatch",
    //   CREATE: "/warehouse/dispatch/create",
    //   DETAIL: (id: string) => `/warehouse/dispatch/detail/${id}`,
    //   UPDATE: (id: string) => `/warehouse/dispatch/update/${id}`,
    //   DELIVERY_DONE: (id: string) => `/warehouse/dispatch/delivery-done/${id}`,
    //   REVERT_DISPATCH: (id: string) => `/warehouse/dispatch/revert/${id}`,
    //   DELETE: (id: string) => `/warehouse/dispatch/delete/${id}`,
    //   STATUS_UPDATE: (id: string) => `/warehouse/dispatch/status/${id}`,
    //   DROPDOWN: "/warehouse/dispatch/dropdown",
    //   FILTER_DROPDOWN: (field: string, warehouse_id: string) =>
    //     `/warehouse/dispatch/filter-dropdown?field_name=${field}&warehouse_id=${warehouse_id}`,
    //   EXPORT: "/warehouse/dispatch/export-csv",
    //   SO_DROPDOWN_FOR_DISPATCH: (warehouse_id: string) =>
    //     `/warehouse/dispatch/sales-order-dropdown-for-dispatch?warehouse_id=${warehouse_id}`,
    //   SO_AND_SHIPPING_ADDRESS_DROPDOWN_FOR_DISPATCH: (
    //     sales_order_product_id: string
    //   ) =>
    //     `/warehouse/dispatch/sales-order-product-with-shipping-address/${sales_order_product_id}`,
    //   PACKING_DROPDOWN_BY_SO_AND_SHIPPING: (
    //     sales_order_product_id: string,
    //     shipping_address_id: string
    //   ) =>
    //     `/warehouse/dispatch/packing-dropdown-by-sales-order-and-shipping?sales_order_product_id=${sales_order_product_id}&shipping_address_id=${shipping_address_id}`,
    // },
  },

  PAYMENT_MANAGEMENT: {
    PRODUCT: {
      LIST: "/payment-management/product/list",
      DETAIL: (id: string) => `/payment-management/product/detail/${id}`,
      UPDATE: (id: string) => `/payment-management/product/update/${id}`,
      DELETE: (id: string) => `/payment-management/product/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/payment-management/product/status/${id}`,
      DROPDOWN: "/payment-management/product/dropdown",
      FILTER_DROPDOWN: (field: string, type?: string) =>
        `/payment-management/product/filter-dropdown?field=${field}${
          type ? `&type=${type}` : ""
        }`,
      EXPORT: "/payment-management/product/export",
    },
    SERVICE: {
      LIST: "/payment-management/service/list",
      DETAIL: (id: string) => `/payment-management/service/detail/${id}`,
      UPDATE: (id: string) => `/payment-management/service/update/${id}`,
      DELETE: (id: string) => `/payment-management/service/delete/${id}`,
      STATUS_UPDATE: (id: string) => `/payment-management/service/status/${id}`,
      DROPDOWN: "/payment-management/service/dropdown",
      FILTER_DROPDOWN: (field: string, type?: string) =>
        `/payment-management/service/filter-dropdown?field=${field}${
          type ? `&type=${type}` : ""
        }`,
      EXPORT: "/payment-management/service/export",
    },
    RECORD_PAYMENT: {
      HISTORY: (id: string, orderType: string, paymentType?: string) => {
        let url = `/payment-management/record-payment/${id}?orderType=${orderType}`;
        if (paymentType) {
          url += `&paymentType=${encodeURIComponent(paymentType)}`;
        }
        return url;
      },
      CREATE: "/payment-management/record-payment/create",
      DELETE: (id: string) => `/payment-management/record-payment/delete/${id}`,
    },
    FOLLOW_UP: {
      CREATE: "/order/follow-up/create",
    },
    // LIST: "/payment-management",
    // CREATE: "/payment-management/create",
    // DETAIL: (id: string) => `/payment-management/detail/${id}`,
    // UPDATE: (id: string) => `/payment-management/update/${id}`,
    // DELETE: (id: string) => `/payment-management/delete/${id}`,
    // STATUS_UPDATE: (id: string) => `/payment-management/status/${id}`,
    // DROPDOWN: "/payment-management/dropdown",
    // FILTER_DROPDOWN: (field: string) =>
    //   `/payment-management/filter-dropdown?field=${field}`,
    // EXPORT: "/payment-management/export",
  },
};
